import React, { useEffect } from 'react'
import useDraftEditor from '../../../hooks/useDraftEditor';
import { Editor } from "react-draft-wysiwyg";

export default function ExlEditDraft({ setValue, value }) {

  const {
    editorState,
    setEditorState,
    editorStateToJsonString,
    jsonStringToEditorState
  } = useDraftEditor(value);

  const handleUpdate = (editorValue) => {
    setEditorState(editorValue);
    setValue(editorStateToJsonString(editorValue));
  }

  useEffect(() => {
    if(value !== editorStateToJsonString(editorState)) {
      setEditorState(jsonStringToEditorState(value));
    }
  }, [value])

  return (
    <Editor
      editorState={editorState}
      onEditorStateChange={handleUpdate}
      wrapperClassName="wrapper-class-edit"
      editorClassName="editor-class"
      toolbarClassName="toolbar-class"
    />
  )
}
